import React from "react"
import RichText from "./richText"
import Buttons from "./buttons"
import CourseButtons from "./buttonsCourse"

import styles from "./cta.module.scss"

const CTA = props => {
  return (
    <div className={styles.cta} data-theme={props.theme}>
      <div className="grid">
        <div className="gridItem xlarge-8 xlarge-offset-2">
          <div className={styles.ctaInner}>
            {props.ctaHeader && (
              <h3 data-larger-header={props.largerCtaHeader}>
                {props.ctaHeader}
              </h3>
            )}
            {props.ctaBody && <RichText blocks={props.ctaBody} />}
            {props.catId && <CourseButtons catId={props.catId} />}
            {props.ctaButton && props.ctaButton.button && (
              <Buttons buttons={props.ctaButton.button} />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default CTA
